import { render, staticRenderFns } from "./PredictionBarChartOverview.vue?vue&type=template&id=5a85bcac&scoped=true"
import script from "./PredictionBarChartOverview.vue?vue&type=script&lang=js"
export * from "./PredictionBarChartOverview.vue?vue&type=script&lang=js"
import style0 from "./PredictionBarChartOverview.vue?vue&type=style&index=0&id=5a85bcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85bcac",
  null
  
)

export default component.exports